export default "__VITE_ASSET__TGv$QOFq__"